import type { NotificationsData } from "../types/notifications";

export async function getNotificationsData(): Promise<NotificationsData> {
	return [];
}
